import { ApiClient } from "@/services/apiClient";
import type { Collectible, CollectibleId } from "@/services/collectibles/collectiblesTypes";

/** @deprecated Still used in magazine widgets. Use Elastic Collectible instead. */
export const fetchCollectibleById = async (id: CollectibleId): Promise<Collectible> => {
  const url = "api-public/collectible/" + id;
  return ApiClient.getPublic<Collectible>(url).then(({ data }) => data);
};
